// DaumAddressSearch.js
// import React, {useEffect, useState, useRef} from 'react';
import { styled  } from '@mui/material/styles';
import { Box } from '@mui/system';
import BusinessIcon from '@mui/icons-material/Business';
import DaumPostcodeEmbed from "react-daum-postcode";
import { AppStyle, AppWord } from '../value/AppConst';

const AddrSearchBox = styled(Box)({
    border: AppStyle.BorderCCC, borderRadius: 3,
});

const HeaderBox = styled(Box)({
    backgroundColor: AppStyle.SuccessRGB, color: 'white',
    minWidth: 520, display: 'flex', alignItems: 'center',
    padding: 10, fontSize: '1.2rem', fontWeight: 'bold',
});

const BodyBox = styled(Box)({minHeight: 400, padding: 0});


/**
 * 다음의 주소 검색을 위한 컴포넌트.
 * Popover의 자식 컴포넌트로 사용된다.
 * @param {*} param0 
 */
export default function DaumAddressSearch({
    open,
    onSelect, // 선택된 주소를 전달하는 콜백함수 ({zipCd, addr}) => {}
}) {

    const onCompletePostSearch = (data) => {
        let fullAddress = Boolean(data.roadAddress) && data.roadAddress.length>0 ? data.roadAddress : data.address;
        let extraAddress = '';
    
        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
        }

        onSelect({zipCd: data.zonecode, addr: fullAddress});
    };
    /*
    data: {
        address: "경남 거제시 장평로 65"
        addressEnglish: "65, Jangpyeong-ro, Geoje-si, Gyeongsangnam-do, Korea"
        addressType: "R"
        apartment: "N"
        autoJibunAddress: "경남 거제시 장평동 228-2"
        autoJibunAddressEnglish: "228-2, Jangpyeong-dong, Geoje-si, Gyeongsangnam-do, Korea"
        autoRoadAddress: ""
        autoRoadAddressEnglish: ""
        bcode: "4831010800"
        bname: "장평동"
        bname1: ""
        bname1English: ""
        bname2: "장평동"
        bname2English: "Jangpyeong-dong"
        bnameEnglish: "Jangpyeong-dong"
        buildingCode: "4831010800102280002000001"
        buildingName: ""
        hname: ""
        jibunAddress: ""
        jibunAddressEnglish: ""
        noSelected: "N"
        postcode: ""
        postcode1: ""
        postcode2: ""
        postcodeSeq: ""
        query: "거제시 장평로 65"
        roadAddress: "경남 거제시 장평로 65"
        roadAddressEnglish: "65, Jangpyeong-ro, Geoje-si, Gyeongsangnam-do, Korea"
        roadname: "장평로"
        roadnameCode: "3337047"
        roadnameEnglish: "Jangpyeong-ro"
        sido: "경남"
        sidoEnglish: "Gyeongsangnam-do"
        sigungu: "거제시"
        sigunguCode: "48310"
        sigunguEnglish: "Geoje-si"
        userLanguageType: "K"
        userSelectedType: "R"
        zonecode: "53268"
    }
    */

    if(!open) return null;

    return (
        <AddrSearchBox>
            <HeaderBox>
                <BusinessIcon fontSize={AppWord.LARGE}/>
                &nbsp;다음 주소 검색
            </HeaderBox>
            <BodyBox>
                <DaumPostcodeEmbed onComplete={onCompletePostSearch} />
            </BodyBox>
        </AddrSearchBox>
    );
}


/*

const handlePostnoComplete=(data)=> {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        this.selectedRow.addr=fullAddress
        this.selectedRow.zip_cd = data.zonecode
        this.daumPostcodeView =false
    }

*/